import { requiredString } from "../utils/Validator";
import Joi from "joi";

export const createWiedervorlageSchema = () => {
    return {
        betreff: requiredString(),
        datum: Joi.date().optional(),
    };
};
